var _defs, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLeftMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    width: 42.45,
    height: 27,
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.9103 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-01{fill:#2f8796;}.cls-02{fill:#1a1a1a;}.cls-03{fill:#60CEFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-01",
    d: "M49.5806,20.247a4.8219,4.8219,0,1,0-4.8219-4.8219A4.8219,4.8219,0,0,0,49.5806,20.247Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-01",
    d: "M35.1152,20.247a4.8219,4.8219,0,1,0-4.8219-4.8219A4.8219,4.8219,0,0,0,35.1152,20.247Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assinatura_Reduzida",
    "data-name": "Assinatura Reduzida"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M0,54A11.5052,11.5052,0,0,0,11.5053,42.4947V37.5805a15.83,15.83,0,0,0,10.98,3.9364c11.4362,0,19.7056-8.9512,19.7056-20.7563C42.1911,8.8731,34.2189,0,22.7891,0A16.4342,16.4342,0,0,0,11.5053,4.0545V.8992H3.2822A3.2822,3.2822,0,0,0,0,4.1814ZM20.9839,31.6639a9.7069,9.7069,0,0,1-9.4769-6.249,12.7925,12.7925,0,0,1-.827-4.6543,12.9424,12.9424,0,0,1,.8253-4.67,9.7277,9.7277,0,0,1,9.4769-6.3127c5.8681.0009,10.1544,4.6637,10.1544,10.9828S26.85,31.6639,20.9839,31.6639Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M45.2793,24.143a1.0916,1.0916,0,0,1-1.089-.9765q-.1176-1.1811-.1184-2.4068A20.5452,20.5452,0,0,1,64.5285.0021,19.8558,19.8558,0,0,1,84.91,19.931c0,1.2142-.0369,2.3176-.1112,3.2054a1.095,1.095,0,0,1-1.0907,1.0066Zm29.1769-7.2955C73.405,11.6582,69.9436,8.424,64.829,8.424s-8.8731,3.0083-10.0028,8.4235A92.4955,92.4955,0,0,1,74.4562,16.8475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-03",
    d: "M81.913,28.52a1.0961,1.0961,0,0,1,.9854,1.5708,20.4219,20.4219,0,0,1-36.8082,0,1.0957,1.0957,0,0,1,.9854-1.5708Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeftMenu);
export default __webpack_public_path__ + "static/media/logo_left_menu.b7e226cd.svg";
export { ForwardRef as ReactComponent };